import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Divider,
  HStack,
  VStack,
  Text,
  FormControl,
  FormLabel,
  Select,
} from "@chakra-ui/react";
import React, { useState } from "react";

interface RejectUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  setReason: (reason: string) => void;
}
const RejectUserModal = ({
  isOpen,
  onClose,
  onSubmit,
  setReason,
}: RejectUserModalProps) => {
  const [closeDrawerLoading, setCloseDrawerLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(event.target.value);
    console.log(event.target.value);
    console.log("selectedOption", selectedOption);
  };

  return (
    <Box
      display={"flex"}
      h={"100%"}
      w={"100%"}
      flexDirection={"column"}
      justifyContent={"flex-start"}
      alignContent={"center"}
      alignItems={"center"}
      textAlign={"left"}
    >
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Reject Approval Request</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <Divider borderColor="gray.300" />
              <FormControl id="dropdown" isRequired>
                <FormLabel>Rejection Reason</FormLabel>
                <Select
                  placeholder="Select option"
                  value={selectedOption}
                  onChange={handleChange}
                >
                  <option value="Invalid Document">Invalid Document</option>
                </Select>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              isLoading={closeDrawerLoading}
              mr={3}
              onClick={async () => {
                if (!selectedOption) {
                  // Handle the case where no option is selected
                  alert(
                    "Please select a valid reason for rejecting this request."
                  );
                  return;
                }
                setReason(selectedOption);
                setCloseDrawerLoading(true);
                setTimeout(() => {
                  onSubmit();
                  onClose();
                  setCloseDrawerLoading(false);
                }, 2000);
              }}
            >
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default RejectUserModal;
